import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { UserApi } from 'mvppoker-portal-common/api'
import React from 'react'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../state/AppStore'
import { updateUser } from '../../../state/reducers/activeUser'
import { setImageProfileLastUpdate } from '../../../state/reducers/AppConfig'
import { useApi } from '../../../utils/useApi'
import { createMVPModal } from '../Modal'
import { ProfileModalView } from './ProfileModalView'

class ProfileModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('profile-modal', () =>
		{
			const modal = useModal()
			const user = useSelector((root: RootState) => root.activeUser.user!)
			const userInfo = user.info
			const userApi = useApi(UserApi)
			const dispatch = useDispatch()
		
			const clickCancel = () => { modal.hide() }

			const clickSubmit = (image: File) => {
				if (image) {
					userApi
					.usersCoreUploadAvatar(image)
					.then((res) => {
						dispatch(updateUser(res.data))
						dispatch(setImageProfileLastUpdate(Date.now()))
						clickCancel()
						toast.success('Success!')
					})
				}else{
					clickCancel()
				}
			}
			const clickContactSupport = () => {
				window.open(`mailto:support@mvppoker.com?subject=Name%20Change%20Request%20userId:${user.id}&body=I%20would%20like%20to%20change%20my%20name%20to`)
			}

			return <ProfileModalView 
				userInfo={userInfo}
				clickSubmit={clickSubmit}
				clickContactSupport={clickContactSupport}
				clickCancel={clickCancel}
			/>
		}))
	}
}

const modal = new ProfileModal()
export default modal